import { useLayoutEffect, useState } from 'react';
var breakPoints = {
    // as they are in storybook
    mobile: { width: 375, height: 844 },
    tablet: { width: 768, height: 1024 },
    desktop: { width: 1440, height: 900 },
};
var getViewport = function () { return ({
    width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
    height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
}); };
var getVisualViewport = function () { return ({
    width: window.visualViewport.width,
    height: window.visualViewport.height,
}); };
export default function useViewport() {
    var _a = useState(getViewport()), viewport = _a[0], setViewport = _a[1];
    var _b = useState(getVisualViewport()), visualViewport = _b[0], setVisualViewport = _b[1];
    useLayoutEffect(function () {
        var handleResize = function () {
            setVisualViewport(getVisualViewport());
            setViewport(getViewport());
        };
        window.visualViewport.addEventListener('resize', handleResize);
        return function () {
            return window.visualViewport.removeEventListener('resize', handleResize);
        };
    }, []);
    return { viewport: viewport, visualViewport: visualViewport, breakPoints: breakPoints };
}
